// extracted by mini-css-extract-plugin
export default {"card":"role_details-module___card___b46e4384","loadingWrapper":"role_details-module___loadingWrapper___e6fe24e8"};